Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.SessionChartListItemCollectionViewFactory
  constructor: (configuredCharts) ->
    @configuredCharts = configuredCharts
    CHARTS = CustomerVisualMode.Charts
    @COMMON_CHARTS = Common.Dashboard.Charts
    @factories = [
      @_singleDimensionFactory(),
      @_defaultFactory('ticket_count', CHARTS.TicketCountChartView),
      @_defaultFactory('operation_current_status', CHARTS.OperationCurrentStatusChartView),
      @_defaultFactory('first_metrics', CHARTS.FirstMetricsForTicketsCreatedInRange),
      @_defaultFactory('first_metrics_calculated_in_range', CHARTS.FirstMetricsCalculatedInRange),
      @_defaultFactory(
        'average_handle_after_assigned_time_per_agent',
        CHARTS.AverageHandleAfterAssignedTimePerAgentChartView
      ),
      @_defaultFactory('recontact_metric', CHARTS.RecontactMetricChartView),
      @_barChartFactory(Common.WidgetDimensions.CLOSED_CONVERSATIONS_PER_AGENT),
      @_configuredFactory('wom_count_metrics', CHARTS.WomCountChartView),
      @_configuredFactory('first_human_response_since_first_human_assignation',
        CHARTS.FirstHumanResponseSinceFirstHumanAssignationChartView),
      @_configuredFactory('average_first_bot_response', CHARTS.AverageFirstBotResponseChartView),
      @_configuredFactory('bot_checkpoints', CHARTS.BotCheckpointsChartView),
      @_configuredFactory('bot_average_interaction_time', CHARTS.BotAverageInteractionTimeChartView),
      @_configuredFactory('ticket_interactions_average', CHARTS.TicketInteractionsAverageChartView),
      @_configuredFactory('management_types', CHARTS.ManagementTypesChartView),
      @_defaultFactory('average_reply_time_per_agent', CHARTS.AverageReplyTimePerAgentBarChart),
      @_defaultFactory('average_handle_after_assigned_time', CHARTS.TimeMetricChartView),
    ]

  create: (session) ->
    factories = _.select(@factories, (factory) => factory.canHandle(@configuredCharts, session))
    _.map(factories, (factory) -> factory.create(session))

  _getTitle: (name) ->
    I18n.t("customer_visual_mode.charts.#{name}.title")

  _getDescription: (name) ->
    I18n.t("customer_visual_mode.charts.#{name}.description", default: '')

  _defaultFactory: (titleName, chartView) ->
    new @COMMON_CHARTS.SessionDefaultChartListItemViewFactory(@_getTitle(titleName), chartView.NAME)

  _configuredFactory: (titleName, chartView) ->
    new @COMMON_CHARTS.SessionConfiguredChartListItemViewFactory(@_getTitle(titleName), chartView.NAME)

  _barChartFactory: (titleName, chartView) ->
    new @COMMON_CHARTS.SessionBarChartListItemViewFactory(@_getTitle(titleName), @_getDescription(titleName), titleName)

  _singleDimensionFactory: ->
    new @COMMON_CHARTS.SessionCustomChartListItemViewFactory
